module.exports = __webpack_public_path__ + "e672e0ef3037adfcbfec862c64dcec7e.png";